import { ApiEnvironment } from '../../models/api-environment';

export class AccountsEnvironment extends ApiEnvironment {
  get companyListUrl() {
    return `${this.baseUrl}/api/v1/company-list`;
  }

  get companyUrl() {
    return `${this.baseUrl}/api/v1/company`;
  }

  get companyAppversionUrl() {
    return `${this.baseUrl}/api/v1/company/appversion`;
  }

  get companyAppversionV2Url() {
    return `${this.baseUrl}/api/v2/company/appversion`;
  }

  get companyEmailSettingsUrl() {
    return `${this.baseUrl}/api/v1/company/emailsettings`;
  }

  get companyLicenseFeaturesUrl() {
    return `${this.baseUrl}/api/v1/company/license/features`;
  }

  get summaryUrl() {
    return `${this.baseUrl}/api/v1/summary`;
  }

  get partnerSettingsUrl() {
    return `${this.baseUrl}/api/v1/partner/settings`;
  }

  get partnerIntegrationUserIdentifiersUrl() {
    return `${this.baseUrl}/api/v1/partner/integration/useridentifiers`;
  }

  get preferencesLanguagesUrl() {
    return `${this.baseUrl}/api/v1/preferences/languages`;
  }

  get preferencesAccountLanguageUrl() {
    return `${this.baseUrl}/api/v1/preferences/account/language`;
  }

  get productsUrl() {
    return `${this.baseUrl}/api/v1/products`;
  }

  get applicationsUrl() {
    return `${this.baseUrl}/api/v1/applications`;
  }

  get resellerReportsLicensesUrl() {
    return `${this.baseUrl}/api/v1/reseller/reports/licenses`;
  }

  get resellerReportsUsersUrl() {
    return `${this.baseUrl}/api/v1/reseller/reports/users`;
  }

  get resellerReportsLicenseSummaryUrl() {
    return `${this.baseUrl}/api/v1/reseller/reports/licensesummary`;
  }

  get supportCopilotFleetActionsUrl() {
    return `${this.baseUrl}/api/v1/support/copilot-fleet-actions`;
  }

  get supportCopilotOnroadEventAlertsUrl() {
    return `${this.baseUrl}/api/v1/support/copilot-onroadevent-alerts`;
  }

  get supportCopilotActionsUrl() {
    return `${this.baseUrl}/api/v1/support/copilot-actions`;
  }

  get usersUrl() {
    return `${this.baseUrl}/api/v1/users`;
  }

  get usersAllUrl() {
    return `${this.baseUrl}/api/v1/users/all`;
  }

  get usersFleetInfoUrl() {
    return `${this.baseUrl}/api/v1/users/fleetinfo`;
  }

  get usersFleetInfoAllUrl() {
    return `${this.baseUrl}/api/v1/users/fleetinfo/all`;
  }

  get usersVehicleHistoryUrl() {
    return `${this.baseUrl}/api/v1/users/vehiclehistory`;
  }

  get amsuiUsersUrl() {
    return `${this.baseUrl}/api/v1/amsui/users`;
  }

  get licenseUrl() {
    return `${this.baseUrl}/api/v1/license`;
  }

  licenseBulkUrl(productId: number) {
    return `${this.baseUrl}/api/v1/license/${encodeURIComponent(
      productId
    )}/bulk`;
  }

  bulkAssetLicenseUrl() {
    return `${this.baseUrl}/api/v1/bulk/assetlicense`;
  }

  bulkAssetInviteUrl() {
    return `${this.baseUrl}/api/v1/bulk/assetinvite`;
  }

  bulkNotifyAssetUrl() {
    return `${this.baseUrl}/api/v1/bulk/notifyasset`;
  }

  bulkAssetPasswordResetUrl() {
    return `${this.baseUrl}/api/v1/bulk/assetpasswordreset`;
  }

  bulkAssetDeleteUrl() {
    return `${this.baseUrl}/api/v1/bulk/assetdelete`;
  }

  get supportCountryCodesUrl() {
    return `${this.baseUrl}/api/v1/support/countrycodes`;
  }

  get deviceLogsUrl() {
    return `${this.baseUrl}/api/v1/device/logs`;
  }

  get configurationSettingsUrl() {
    return `${this.baseUrl}/api/v1/configuration/settings`;
  }

  configurationSettingsAccountAliasPaginatedUrl(alias: string) {
    return `${this.baseUrl}/api/v1/configuration/settings/account/${alias}/paginated`;
  }

  get companyMapDataVersionUrl() {
    return `${this.baseUrl}/api/v1/company/mapdataversion`;
  }

  override resolve(environment: unknown) {
    return environment instanceof AccountsEnvironment ? environment : this;
  }
}

export const accountsEnvironment = new AccountsEnvironment();
